import apiV1 from 'redux/api/v1';
import {
  getProjectById,
  putProjectName,
  putProjectModelDraft,
  CREATE_PROJECT,
  putValidateGraphEndpoint,
  getRecommendationEndpoint,
  getDuplicateProject,
  getRemoveProject,
  putGetNotebookEndpoint,
} from 'constants/endpoints';

export const CLEAR_RPOJECT = 'project/CLEAR_PROJECT';

export const GET_PROJECT = 'project/GET_PROJECT';
export const GET_PROJECT_LOADING = 'project/GET_PROJECT_LOADING';
export const GET_PROJECT_FULFILLED = 'project/GET_PROJECT_FULFILLED';
export const GET_PROJECT_REJECTED = 'project/GET_PROJECT_REJECTED';

export const CREATE_PROJECT_LOADING = 'project/CREATE_PROJECT_LOADING';
export const CREATE_PROJECT_FULFILLED = 'project/CREATE_PROJECT_FULFILLED';
export const CREATE_PROJECT_REJECTED = 'project/CREATE_PROJECT_REJECTED';

export const PUT_PROJECT_NAME = 'project/PUT_PROJECT_NAME';
export const PUT_PROJECT_NAME_LOADING = 'project/PUT_PROJECT_NAME_LOADING';
export const PUT_PROJECT_NAME_FULFILLED = 'project/PUT_PROJECT_NAME_FULFILLED';
export const PUT_PROJECT_NAME_REJECTED = 'project/PUT_PROJECT_NAME_REJECTED';

export const PUT_PROJECT_MODEL_DRAFT = 'project/PUT_PROJECT_MODEL_DRAFT';
export const PUT_PROJECT_MODEL_DRAFT_LOADING = 'project/PUT_PROJECT_MODEL_DRAFT_LOADING';
export const PUT_PROJECT_MODEL_DRAFT_FULFILLED = 'project/PUT_PROJECT_MODEL_DRAFT_FULFILLED';
export const PUT_PROJECT_MODEL_DRAFT_REJECTED = 'project/PUT_PROJECT_MODEL_DRAFT_REJECTED';

export const PUT_PROJECT_MODEL_VALIDATE_LOADING = 'project/PUT_PROJECT_MODEL_VALIDATE_LOADING';
export const PUT_PROJECT_MODEL_VALIDATE_FULFILLED = 'project/PUT_PROJECT_MODEL_VALIDATE_FULFILLED';
export const PUT_PROJECT_MODEL_VALIDATE_REJECTED = 'project/PUT_PROJECT_MODEL_VALIDATE_REJECTED';

export const GET_LAYER_RECO_LOADING = 'project/GET_LAYER_RECO_LOADING';
export const GET_LAYER_RECO_FULFILLED = 'project/GET_LAYER_RECO_FULFILLED';
export const GET_LAYER_RECO_REJECTED = 'project/GET_LAYER_RECO_REJECTED';

export const GET_PROJECT_REMOVE_LOADING = 'project/GET_PROJECT_REMOVE_LOADING';
export const GET_PROJECT_REMOVE_FULFILLED = 'project/GET_PROJECT_REMOVE_FULFILLED';
export const GET_PROJECT_REMOVE_REJECTED = 'project/GET_PROJECT_REMOVE_REJECTED';

export const GET_PROJECT_DUPLICATE_LOADING = 'project/GET_PROJECT_DUPLICATE_LOADING';
export const GET_PROJECT_DUPLICATE_FULFILLED = 'project/GET_PROJECT_DUPLICATE_FULFILLED';
export const GET_PROJECT_DUPLICATE_REJECTED = 'project/GET_PROJECT_DUPLICATE_REJECTED';

export const GET_PROJECT_DOWNLOAD_LOADING = 'project/GET_PROJECT_DOWNLOAD_LOADING';
export const GET_PROJECT_DOWNLOAD_FULFILLED = 'project/GET_PROJECT_DOWNLOAD_FULFILLED';
export const GET_PROJECT_DOWNLOAD_REJECTED = 'project/GET_PROJECT_DOWNLOAD_REJECTED';


export function fetchProject(id) {
  return async function (dispatch) {
    dispatch({ type: GET_PROJECT_LOADING, data: { loading: true } });
    try {
      const project = await apiV1.get(getProjectById(id));
      return dispatch({ type: GET_PROJECT_FULFILLED, data: { project, loading: false } });
    } catch (error) {
      return dispatch({ type: GET_PROJECT_REJECTED, data: { loading: false, error } });
    }
  };
};

// Edit Project Name
export function editProjectName(id, name) {
  return async function (dispatch) {
    dispatch({ type: PUT_PROJECT_NAME_LOADING, data: { loading: true } });
    try {
      await apiV1.put(putProjectName(id), { body: { name } });
      const project = await apiV1.get(getProjectById(id));
      return dispatch({ type: PUT_PROJECT_NAME_FULFILLED, data: { project, loading: false } });
    } catch (error) {
      return dispatch({ type: PUT_PROJECT_NAME_REJECTED, data: { loading: false, error } });
    }
  };
};

// Edit Project Model Draft
export function editProjectModelDraft(id, { id: modelId, model, serialized_model }) {
  return async function (dispatch) {
    dispatch({ type: PUT_PROJECT_MODEL_DRAFT_LOADING, data: { loading: true } });
    try {
      await apiV1.put(putProjectModelDraft(id, modelId), { body: { model, serialized_model } });
      const project = await apiV1.get(getProjectById(id));
      dispatch({ type: PUT_PROJECT_MODEL_DRAFT_FULFILLED, data: { project, loading: false } });

      try {
        dispatch({ type: PUT_PROJECT_MODEL_VALIDATE_LOADING });
        const data = await apiV1.put(putValidateGraphEndpoint(id), { body: { model } });
        dispatch({ type: PUT_PROJECT_MODEL_VALIDATE_FULFILLED, data });
      } catch (e) {
        dispatch({ type: PUT_PROJECT_MODEL_VALIDATE_REJECTED });
      }

    } catch (error) {
      return dispatch({ type: PUT_PROJECT_MODEL_DRAFT_REJECTED, data: { loading: false, error } });
    }
  };
};

// Create Project
export function createProject(project) {
  return async function (dispatch) {
    dispatch({ type: CREATE_PROJECT_LOADING });
    try {
      const data = await apiV1.post(CREATE_PROJECT, { body: project });
      dispatch({ type: CREATE_PROJECT_FULFILLED, data });
    } catch (error) {
      dispatch({ type: CREATE_PROJECT_REJECTED, data: { error } });
    }
  };
};

// Duplciate Project
export function duplicateProject(id) {
  return async function (dispatch) {
    dispatch({ type: GET_PROJECT_DUPLICATE_LOADING });
    try {
      const data = await apiV1.put(getDuplicateProject(id));
      dispatch({ type: GET_PROJECT_DUPLICATE_FULFILLED, data });
    } catch (error) {
      dispatch({ type: GET_PROJECT_DUPLICATE_REJECTED, data: { error } });
    }
  };
};

// Duplciate Project
export function removeProject(id) {
  return async function (dispatch) {
    dispatch({ type: GET_PROJECT_REMOVE_LOADING });
    try {
      const data = await apiV1.put(getRemoveProject(id));
      dispatch({ type: GET_PROJECT_REMOVE_FULFILLED, data });
    } catch (error) {
      dispatch({ type: GET_PROJECT_REMOVE_REJECTED, data: { error } });
    }
  };
};

// Validate Model
export function validateGraph(id, { model }) {
  return async function (dispatch) {
    dispatch({ type: PUT_PROJECT_MODEL_VALIDATE_LOADING });
    try {
      const data = await apiV1.put(putValidateGraphEndpoint(id), { body: { model } });
      dispatch({ type: PUT_PROJECT_MODEL_VALIDATE_FULFILLED, data });
    } catch (error) {
      dispatch({ type: PUT_PROJECT_MODEL_VALIDATE_REJECTED, data: { error } });
    }
  };
};

// Get layer recommendation
export function getRecommendations(id, layerId) {
  return async function (dispatch) {
    dispatch({ type: GET_LAYER_RECO_LOADING });
    try {
      const data = await apiV1.get(getRecommendationEndpoint(id, layerId), {});
      dispatch({ type: GET_LAYER_RECO_FULFILLED, data });
    } catch (error) {
      dispatch({ type: GET_LAYER_RECO_REJECTED, data: { error } });
    }
  };
};

// Get layer recommendation
export function downloadProject(projectId, model) {
  return async function (dispatch) {
    try {
      dispatch({ type: GET_PROJECT_DOWNLOAD_LOADING });
      const data = await apiV1.put(putValidateGraphEndpoint(projectId), { body: { model } });
      dispatch({ type: PUT_PROJECT_MODEL_VALIDATE_FULFILLED, data });
      if (data.status === 'SUCCESS') {
        const response = await apiV1.put(putGetNotebookEndpoint(projectId), { body: { model } });
        if (response?.data && response?.status === 'SUCCESS') {
          const tempLink = document.createElement('a');
          tempLink.target = '_blank';
          tempLink.href = response?.data;
          tempLink.click();
          dispatch({ type: GET_PROJECT_DOWNLOAD_FULFILLED });
        } else {
          throw { message: response?.data || 'Project download failed' };
        }
      } else {
        throw { message: 'Project download failed' };
      }
    } catch (error) {
      dispatch({ type: GET_PROJECT_DOWNLOAD_REJECTED, data: error });
    }
  };
};

// Get layer recommendation
export function clearProject() {
  return async function (dispatch) {
    dispatch({ type: CLEAR_RPOJECT });
  };
};